export default __webpack_public_path__ + "static/media/logo.e0fbdca3.png";